import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EditSalarySetupForm from "./components/EditSalarySetupForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { GetById, Update } from "adminApi/SalarySetupApi/SalarySetup";
import Spinner from "Common/Globle/Spinner";

const EditSalarySetup = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const initialValues = {
        employee_id: "",
        salary_data: [],
    };

    const { values, handleChange, setValues, errors, setErrors } = useFormChange(initialValues);
    const [fetchLoading, setFetchLoading] = useState(true);

    // Fetch existing salary setup by ID
    useEffect(() => {
        if (!id) return;
        const fetchData = async () => {
            setFetchLoading(true);
            try {
                const res = await GetById(id);
                if (res?.data?.success && res.data.data) {
                    const data = res.data.data;
                    console.log("data", data)
                    setValues({
                        employee_id: data.employee_id,
                        // Backend returns percent (mapped from amount_percentage)
                        // amount is the actual currency value
                        salary_data: (data.salary_data || []).map(item => ({
                            ...item,
                            percent: item.percent !== undefined ? item.percent : 0,
                            amount: item.amount !== undefined ? item.amount : 0,
                        })),
                    });
                }
            } catch (err) {
                console.error("EditSalarySetup fetch error:", err);
            } finally {
                setFetchLoading(false);
            }
        };
        fetchData();
    }, [id, setValues]);

    const { handleSubmit, loading } = useFormSubmit(
        async (vals) => await Update({ id, data: vals }),
        (vals) => {
            const err = {};
            if (!vals.employee_id) err.employee_id = "Employee is required";
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Salary Setup updated successfully"
    );

    if (fetchLoading) return <Spinner isSpinner={true} />;

    return (
        <EditSalarySetupForm
            values={values}
            handleChange={handleChange}
            setValues={setValues}
            handleSubmit={(e) => handleSubmit(e, values)}
            loading={loading}
            errors={errors}
            setErrors={setErrors}
            title="Edit Salary Setup"
        />
    );
};

export default EditSalarySetup;
